import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import type { IntlMessageId } from '@/types/intl.ts';

type OrderRowProps = {
  labelId: IntlMessageId;
  alignTop?: boolean;
};

export const OrderRow = (props: PropsWithChildren<OrderRowProps>) => {
  const { labelId, alignTop = false, children } = props;

  return (
    <>
      <div className={clsx('fs-12 fw-medium text-secondary text-nowrap text-end', { 'align-self-start': alignTop })}>
        <FormattedMessage id={labelId} />
      </div>

      <div>{children}</div>
    </>
  );
};
